import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMoneyBillWave, faThList, faUserCog, faWallet} from '@fortawesome/free-solid-svg-icons'
import {NavLink} from "react-router-dom";

const Navbar = () => {
    return (
        <React.Fragment>
            <nav className="nav nav-pills nav-justified fixed-bottom rtl max-w-lg bg-light">
                <NavLink className="nav-item nav-link  " to="/home">
                    <div><FontAwesomeIcon icon={faThList}/></div>
                    <span className="super-small-2">گزارش درخواست ها</span>
                </NavLink>
{/*                <NavLink className="nav-item nav-link  " to="/completed">
                    <div><FontAwesomeIcon icon={faThList}/></div>
                    <span className="super-small-2">تکمیل شده ها</span>
                </NavLink>*/}
{/*                <NavLink className="nav-item nav-link  " to="/owners">
                    <div><FontAwesomeIcon icon={faMoneyBillWave}/></div>
                    <span className="super-small-2">تخصیص</span>
                </NavLink>
                <NavLink className="nav-item nav-link  " to="/users-wallet">
                    <div><FontAwesomeIcon icon={faWallet}/></div>
                    <span className="super-small-2 ">کیف پول</span>
                </NavLink>*/}
               {/* <NavLink className="nav-item nav-link  " to="/work-shifts">
                    <div><FontAwesomeIcon icon={faCheck}/></div>
                    <span className="super-small-2"> پروفایل</span>
                </NavLink>*/}
                <NavLink className="nav-item nav-link  " to="/profile">
                    <div><FontAwesomeIcon icon={faUserCog}/></div>
                    <span className="super-small-2">پروفایل</span>
                </NavLink>
            </nav>
        </React.Fragment>
    );
};

export default Navbar;
